import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import HOCButton from "web/components/Button";
import NumberInput from "web/components/form-elements/NumberInput";
import TextArea from "web/components/form-elements/TextArea";
import DatePicker from 'web/components/form-elements/DatePicker';
import Spinner from '../../../../components/Spinner'
import { adminClaimFeeCalculate } from '../../../../../redux/actions/admin';
import AlertModal from 'web/components/AlertModal';
import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";
import {
  ClaimInfoSection,
  ResolutionModalInnerBoxes,
  ProcessWithSection,
  SummarySection,
  ExchangeDateSection,
  SubmitButtonWrapper,
} from "./ClaimStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";

function ResolutionModal(props) {
  let claimResolutionType = props.claimResolutionType
  let claimDetails = props.claimDetails
  let dispatch = useDispatch()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
  const [summaryInfoValues, setSummaryInfoValues] = useState()
  const [modal, setModal] = useState(false)
  const [modalContent, setModalContent] = useState('')

  const [tooltip, setTooltip] = useState(false)
  const [tooltipSection, settTooltipSection] = useState("")

  const [modalConstants, setModalConstants] = useState()

  useEffect(() => {
    let modalHeaderTemp = '', modalDescriptionTemp = '', modalSummaryInfoTemp = '', modalNoteTemp = ''
    if (claimResolutionType === "exchangePopUp") {
      modalHeaderTemp = 'Exchange or Supply Missing'
      modalDescriptionTemp = 'The Seller is responsible for the delivery the pallets for damaged and missing Quantity.'
      modalSummaryInfoTemp = 'Amount withheld to seller for payment until exchange order completed.'
      modalNoteTemp = 'Note : New orders ID has been created in open orders with tag exchange order and can be seen by both Seller & buyer.'
    } else if (claimResolutionType === "issueCreditPopUp") {
      modalHeaderTemp = 'Issue Credit for Missing or Damaged'
      modalDescriptionTemp = 'Issue Credit to buyer for missing or damaged pallets.'
      modalSummaryInfoTemp = 'This amount will not be taken from Buyer. Seller will not paid this amount.'
      modalNoteTemp = 'Updated Receipt will be generated to buyer and seller can be seen in complete orders.'
    } else if (claimResolutionType === "noActionPopUp") {
      modalHeaderTemp = 'No Action'
      modalDescriptionTemp = 'The claim has been moved to complete as per the original Order qty. No settlement made.'
    } else if (claimResolutionType === "ptOverridePopUp") {
      modalHeaderTemp = 'PT Override'
      modalDescriptionTemp = 'The Amount will be settled through Our PalletTrader account and Need to be approve by the super Admin only.'
      modalSummaryInfoTemp = 'Settlement to buyer will be done from PT account.'
    }
    setModalConstants({
      modalHeader: modalHeaderTemp,
      modalDescription: modalDescriptionTemp,
      modalSummaryInfo: modalSummaryInfoTemp,
      modalNote: modalNoteTemp
    })
  }, [props])

  const calcualteFunction = async (value) => {
    let response = '';
    let data = { orderId: claimDetails.orderId, adjustmentAmount: value }
    response = await dispatch(adminClaimFeeCalculate(data));
    if (response.status === 'SUCCESS') {
      setSummaryInfoValues(response.payload)
    }
  }

  let dateSet = new Date()
  const INITIAL_VALUES = {
    fixedAmount: '',
    adminClaimQuantity: '',
    adminClaimQuality: '',
    exchangeDate: dateSet,
    comments: ''
  };

  const VALIDATION_SCHEMA = Yup.object().shape({
  });

  const toggle = () => {
    props.toggle();
  };

  const adminClaimResolveFunction = propsVal => {
    if (((propsVal.values.adminClaimQuality !== '' && parseFloat(propsVal.values.adminClaimQuality)) + (propsVal.values.adminClaimQuantity !== '' && parseFloat(propsVal.values.adminClaimQuantity))) > claimDetails?.totalLotQty) {
      setModalContent('Resolving claim quantity should not be greater than the total quantity.')
      setModal(!modal)
    } else if (propsVal.values.comments?.length < 10) {
      setModalContent('Comment should have atleast 10 characters.')
      setModal(!modal)
    } else props.resolveClaimFunctionCallBack(propsVal.values)
  }

  const showToolTip = (infoSection, infoTxt) => {
    return (
      <>
        <img
          id={infoSection}
          src={information}
          style={{ position: "relative", top: "-1px", marginLeft: "6px", }}
          alt=""
        />
        <Tooltip
          placement="right"
          isOpen={tooltip && tooltipSection === infoSection}
          target={infoSection}
          toggle={() => {
            setTooltip(!tooltip);
            settTooltipSection(tooltipSection === "" ? infoSection : "");
          }}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  return (
    <>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => { }}
      >
        {(props) => {
          const { setFieldValue } = props;
          return (
            <div className={claimResolutionType === "ptOverridePopUp" && "red-outline"}>
              <Form>
                {loaderVisible && <Spinner />}
                <ResolutionModalInnerBoxes>
                  <div className={"exchange-modal-header"}>
                    <h1>{modalConstants?.modalHeader}</h1>
                    <img src={CloseIcon} alt="close-icon" onClick={toggle} />
                  </div>
                </ResolutionModalInnerBoxes>

                <div>
                  <p style={{ margin: '7px 0px 0px 10px' }}>{modalConstants?.modalDescription}</p>
                </div>

                {claimResolutionType !== 'noActionPopUp' &&
                  <>
                    <ClaimInfoSection>
                      <div className=" mx-2 my-2 claim-info-section">
                        <h6>Claim Info</h6>
                        <div className="claim-info">
                          {claimDetails?.totalPalletQuantity &&
                            <div>
                              <p>Missing Quantity</p>
                              <p>{claimDetails?.totalPalletQuantity}</p>
                            </div>
                          }
                          {claimDetails?.totalPalletQuality &&
                            <div>
                              <p>Damage quantity</p>
                              <p>{claimDetails?.totalPalletQuality}</p>
                            </div>
                          }
                          <div>
                            <p>Total Claim Quantity</p>
                            <p>{claimDetails?.totalPalletQuality + claimDetails?.totalPalletQuantity}</p>
                          </div>
                          <div>
                            <p>Base Cost</p>
                            <p>$ {claimDetails?.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                          </div>
                          <div>
                            <p>Total claim amount</p>
                            <p>$ {claimDetails?.claimTotalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                          </div>
                        </div>
                      </div>
                    </ClaimInfoSection>
                    <ProcessWithSection>
                      <div className=" mx-2 my-2 process-with-section">
                        <p>Process with: Replace with Settlement details</p>
                        {claimDetails?.totalPalletQuantity &&
                          <div className="process-with">
                            <p>Replacement Qty<span style={{ color: '#a30202' }}>&#42;</span>
                              <span>{showToolTip("quantityToolTip", "Qty that the seller will replace")}</span>
                            </p>
                            <NumberInput
                              name='adminClaimQuantity'
                              maxAllowedValueLimit={claimDetails?.totalLotQty}
                              onChangeHandler={(value) => {
                                let totalClaimCount = parseFloat(value) + parseFloat(props.values.adminClaimQuality !== '' ? props.values.adminClaimQuality : 0)
                                setFieldValue('fixedAmount', totalClaimCount * claimDetails.pricePerPallet || '')
                                calcualteFunction(totalClaimCount * claimDetails.pricePerPallet)
                              }}
                            />
                          </div>
                        }
                        {claimDetails?.totalPalletQuality &&
                          <div className="process-with">
                            <p>Replacement for Bad Quality<span style={{ color: '#a30202' }}>&#42;</span>
                              <span>{showToolTip("qualityToolTip", "Seller will redeliver pallets for bad quality")}</span>
                            </p>
                            <NumberInput
                              name='adminClaimQuality'
                              maxAllowedValueLimit={claimDetails?.totalLotQty}
                              onChangeHandler={(value) => {
                                let totalClaimCount = parseFloat(value) + parseFloat(props.values.adminClaimQuantity !== '' ? props.values.adminClaimQuantity : 0)
                                setFieldValue('fixedAmount', totalClaimCount * claimDetails.pricePerPallet || '')
                                calcualteFunction(totalClaimCount * claimDetails.pricePerPallet)
                              }}
                            />
                          </div>
                        }
                      </div>
                    </ProcessWithSection>
                    {claimResolutionType === 'exchangePopUp' &&
                      <ExchangeDateSection>
                        <div className=" mx-2 my-2 exchange-date-section">
                          <p>Exchange Date<span>{showToolTip("exchangeDate", "Seller agreed to make pallet available to buyer as per delivery mode")}</span></p>
                          <div className="exchange-info">
                            <DatePicker
                              name='exchangeDate'
                              placeholderText=''
                            />
                          </div>
                        </div>
                      </ExchangeDateSection>
                    }
                    <SummarySection>
                      <div className="mx-2 my-2 summary-section">
                        <p>Summary<span>{showToolTip("summarySection", modalConstants?.modalSummaryInfo)}</span></p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(205px, 1fr))' }}>
                          <div className="summary-info">
                            <h6>Adjusted Seller Remittance</h6>
                            <div>
                              <p>Qty</p>
                              <p>{parseFloat(props.values.adminClaimQuantity !== '' ? props.values.adminClaimQuantity : 0) +
                                parseFloat(props.values.adminClaimQuality !== '' ? props.values.adminClaimQuality : 0)}</p>
                            </div>
                            <div>
                              <p>Base</p>
                              <p>$ {claimDetails?.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total Base</p>
                              <p>{summaryInfoValues && '$'} {claimResolutionType === "ptOverridePopUp" ? '0' : summaryInfoValues?.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total PT Fee</p>
                              <p>{summaryInfoValues && '$'} {claimResolutionType === "ptOverridePopUp" ? '0' : summaryInfoValues?.sellerFee?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div><p></p><p></p></div><div><p></p><p></p></div>
                            <hr />
                            <div>
                              <p>Total Adjusted Rem</p>
                              <p>{summaryInfoValues && '$'} {claimResolutionType === "ptOverridePopUp" ? '0' : summaryInfoValues?.totalSellerPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                          </div>
                          <div className="summary-info">
                            <h6>Adjusted Buyer Receivable</h6>
                            <div>
                              <p>Qty</p>
                              <p>{parseFloat(props.values.adminClaimQuantity !== '' ? props.values.adminClaimQuantity : 0) +
                                parseFloat(props.values.adminClaimQuality !== '' ? props.values.adminClaimQuality : 0)}</p>
                            </div>
                            <div>
                              <p>Base</p>
                              <p>$ {claimDetails?.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total Base</p>
                              <p>{summaryInfoValues && '$'} {summaryInfoValues?.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total PT Fee</p>
                              <p>{summaryInfoValues && '$'} {summaryInfoValues?.buyerFee?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total Tax</p>
                              <p>{summaryInfoValues && '$'} {summaryInfoValues?.taxAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Payment Ent Fee</p>
                              <p>{summaryInfoValues && '$'} {summaryInfoValues?.stripeFee?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <hr />
                            <div>
                              <p>Total Adjusted Paya</p>
                              <p>{summaryInfoValues && '$'} {summaryInfoValues?.totalBuyerPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SummarySection>
                  </>
                }

                <div>
                  {claimResolutionType === "exchangePopUp" && (
                    <p style={{ margin: '10px 0px 7px 10px' }}>{modalConstants?.modalNote}</p>
                  )}
                </div>

                <div className="mx-2">
                  <p className="mt-0" style={{ color: '#3d91c5' }}>Comments<span style={{ color: '#a30202' }}>&#42;</span>
                    <span>{showToolTip("commentValidation", "Comment should have atleast 10 characters")}</span></p>
                  <TextArea name="comments" showErrorMessages={true} />
                </div>

                <SubmitButtonWrapper>
                  <div className="submit-button-wrapper">
                    <HOCButton
                      type="app-green-button submitBtn"
                      handleClick={() => adminClaimResolveFunction(props)}
                      disabled={(props.values.comments === '' ||
                        (props.values.exchangeDate === 'Invalid date' && claimResolutionType === 'exchangePopUp') ||
                        (claimDetails?.totalPalletQuality && props.values.adminClaimQuality === '' && claimResolutionType !== 'noActionPopUp') ||
                        (claimDetails?.totalPalletQuantity && props.values.adminClaimQuantity === '' && claimResolutionType !== 'noActionPopUp'))}
                    >
                      Submit
                    </HOCButton>
                  </div>
                </SubmitButtonWrapper>
              </Form>
            </div>
          );
        }}
      </Formik>
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        content={modalContent}
      />
    </>
  );
}

export default ResolutionModal;
